import Treeselect from './vue-treeselect/src/components/Treeselect';
import './vue-treeselect/src/style.less';
export default Treeselect;
